var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',_vm._g(_vm._b({attrs:{"title":"分享到微信","width":"300px"}},'el-dialog',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"fr"},[_c('qrcode-vue',{attrs:{"value":_vm.codeUrl,"size":250}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }